import React, { useState, useEffect } from 'react';
import './App.css';
import LogoBanner from './components/LogoBanner';
import Header from './components/Header';
import Hero from './components/Hero';
import VisionMission from './components/VisionMission';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    // Set initial direction and language
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  return (
    <div className="App">
      <LogoBanner />
      <Header language={language} onLanguageChange={handleLanguageChange} />
      <Hero language={language} />
      <VisionMission language={language} />
      <Services language={language} />
      <Contact language={language} />
      <Footer language={language} />
    </div>
  );
}

export default App;
